import { withModalProvider } from "../../hoc/withModalProvider";
import { LockUnlockButtonGroup as View, IProps } from "./LockUnlockButton";

export const LockUnlockButtonGroup = withModalProvider<IProps>(View);
